
        Component.define('podcast-newsletter', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

 const $el   = $(el);
 const $form = $el.find('.form-contact');

 const api = ws_url + '/newsletter-podcast';

 let successEN = 'Thanks! :)';
 let successPT = 'Obrigadx! :)';

 $form.on('submit', function(event) {
     event.preventDefault();

     const $this   = $(this);
     const $button = $this.find('button.btn-send-form');

     const $name = $this.find('[name="nome"]');
     const $email = $this.find('[name="email"]');

     const data = {
         name: $name.val(),
         email: $email.val(),
         lang: lang,
     };

     $button.addClass('loading').prop('disabled', true);

     $name.prop('disabled', true);
     $email.prop('disabled', true);

     $.post(api, data).then((res) => {

         if(res.success) {

             $button.find('span').text(lang == 'en' ? successEN : successPT);

             $name.val('');
             $email.val('');

         } else {
             alert(lang == 'en' ? 'E-mail not saved.' : 'E-mail não salvo.');
         }

         $button.removeClass('loading').prop('disabled', false);

         $name.prop('disabled', false);
         $email.prop('disabled', false);
     });
 });

        });